import React from 'react';
import '../scss/components/Ads.scss';


const ADS_ENABLED = true;

export const AnonAdLanding = () => {
  if (!ADS_ENABLED) return null;
  return (
    <div id="ad-landing-wrap">
      <iframe
        id="ad-landing"
        title="a-ads"
        data-aa='2187775'
        src='https://ad.a-ads.com/2187775?size=468x60'
      ></iframe>
    </div>
  );
};

export const AnonAdCorner = () => {
  if (!ADS_ENABLED) return null;
  return (
    <div id="ad-corner-wrap">
      <iframe
        id="ad-corner"
        title="a-ads"
        data-aa='2187775'
        src='https://ad.a-ads.com/2187775?size=468x60'
      ></iframe>
    </div>
  );
};
